
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from 'react';
import { GetServerSidePropsContext, GetServerSidePropsResult, NextPage } from 'next';
import useTranslation from 'next-translate/useTranslation';
import styles from './index.module.scss';
import Layout from 'components/Layout';
import { Namespace } from 'enums/namespaces';
import classNames from 'classnames';
import { useAuth, withForcePlanToLoggedInUnsubs } from 'context';
import Head from 'next/head';
import { basicSEO, createRedirectIfNeeded, getNoTrialTranslationKeyIfNeeded } from 'helpers';
import { StaticPathParams } from 'typings/staticPaths';
import { authorizeUserServerSide } from 'api/firebaseAdmin';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Props {
  countryCode: string;
}

const Samsung: NextPage<Props> = ({ countryCode }) => {
  const { t } = useTranslation(Namespace.MobileApps);
  const { user } = useAuth();

  return (
    <Layout countryCode={countryCode}>
      <Head>
        {basicSEO(
          t('seo:how_to_watch_mobile_android_title'),
          t(getNoTrialTranslationKeyIfNeeded('seo:how_to_watch_mobile_android_description', countryCode)),
        )}
      </Head>
      <main className={[styles.container].join(' ')}>
        <h1>{t('android_title')}</h1>
        <p className={styles.desc} dangerouslySetInnerHTML={{ __html: t('android_description') }}></p>
        <h2>{t('android_instalation')}</h2>
        <ol>
          <li>
            <p dangerouslySetInnerHTML={{ __html: t('android_step_1') }}></p>
            <div className={classNames(styles.img, styles['step-1'])} />
          </li>
          <li>
            <p dangerouslySetInnerHTML={{ __html: t('android_step_2') }}></p>
            <div className={classNames(styles.img, styles['step-2'])} />
          </li>
          <li>
            <p dangerouslySetInnerHTML={{ __html: t('android_step_3') }}></p>
            <div className={classNames(styles.img, styles['step-3'])} />
          </li>
          <li>
            <p dangerouslySetInnerHTML={{ __html: t('android_step_4') }}></p>
            <div className={classNames(styles.img, styles['step-4'])} />
          </li>
          <li>
            <p dangerouslySetInnerHTML={{ __html: t('android_step_5') }}></p>
          </li>
        </ol>
      </main>
    </Layout>
  );
};

 async function _getServerSideProps(
  ctx: GetServerSidePropsContext<StaticPathParams>,
): Promise<GetServerSidePropsResult<Props>> {
  const { locale, apiClient, countryCode } = await authorizeUserServerSide(ctx);

  const redirect = createRedirectIfNeeded(ctx, locale);
  if (redirect) {
    return redirect;
  }

  return {
    props: { countryCode },
  };
}

export default withForcePlanToLoggedInUnsubs(Samsung);


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/how-to-watch/mobile-apps/google-android/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  